$(function() {
    var passwordField = $('input[id$="DNN_txtPassword"]');
    var eye = $('<i class="fa fa-eye" title="Show/hide password" aria-hidden="true"></i>');
    passwordField.after(eye);
    passwordField.attr('type', 'password');
    passwordField.next().click(function() {
        if (passwordField.attr('type') == 'password') {
            passwordField.attr('type', 'text');
            passwordField.next().removeClass('fa-eye').addClass('fa-eye-slash');
        } else {
            passwordField.attr('type', 'password');
            passwordField.next().removeClass('fa-eye-slash').addClass('fa-eye');
        }
    });
});

var buSwitcher = $('#businessUnitSwitcher');
var buSwitcherMenu = $('#businessUnitSwitcherMenu');
buSwitcher.on('click', function(e) {
    e.preventDefault();
    buSwitcherMenu.toggleClass('js-show');
});